import moment from "moment";
import { IDateRangeValue } from "./interface";

export const getThisMonth: () => IDateRangeValue = () => {
  const today = new Date();

  return [
    moment(today).startOf("month").toDate(),
    moment(today).endOf("month").toDate(),
  ];
};

export const getThisYear: () => IDateRangeValue = () => {
  const today = new Date();

  return [
    moment(today).startOf("year").toDate(),
    moment(today).endOf("year").toDate(),
  ];
};
